import { get as _get } from "lodash";
import api from "../../helpers/api";

export const fetchWebScrapingFilters = () => {

  return api().get("/search/web_scraping_filter").then((res) => {
    return {
      flag: true,
      statusCode: (res.status || 200),
      message: _get(res, "data.responseMessage", ""),
      data: _get(res, "data.responseData", {})
    };
  }).catch((err) => {
    return {
      flag: false,
      statusCode: (err.status || 400),
      message: _get(err, "response.data.responseMessage", "Something went wrong while fetching web scraping filters."),
      data: {}
    };
  });
}

export const getWebScrapingDashboard = (variables) => {

  return api().options("/search/web_scraping_dashboard", { data: (variables || {}) }).then((res) => {
    return {
      flag: true,
      statusCode: (res.status || 200),
      message: _get(res, "data.responseMessage", ""),
      data: _get(res, "data.responseData", {})
    };
  }).catch((err) => {
    return {
      flag: false,
      statusCode: (err.status || 400),
      message: _get(err, "response.data.responseMessage", "Something went wrong while fetching web scraping dashboard data."),
      data: {}
    };
  });
}

export const getWebScrapingData = (variables) => {

  return api().options("/search/web_scraping_data", { data: (variables || {}) }).then((res) => {
    return {
      flag: true,
      statusCode: (res.status || 200),
      message: _get(res, "data.responseMessage", ""),
      data: _get(res, "data.responseData", {})
    };
  }).catch((err) => {
    return {
      flag: false,
      statusCode: (err.status || 400),
      message: _get(err, "response.data.responseMessage", "Something went wrong while fetching web scraping data."),
      data: {}
    };
  });
}

export const exportWebScrapingData = (variables) => {

  return api().options("/search/web_scraping_export", { data: (variables || {}) }).then((res) => {
    return {
      flag: true,
      statusCode: (res.status || 200),
      message: _get(res, "data.responseMessage", ""),
      data: _get(res, "data.responseData", {})
    };
  }).catch((err) => {
    return {
      flag: false,
      statusCode: (err.status || 400),
      message: _get(err, "response.data.responseMessage", "Something went wrong while exporting web scraping data."),
      data: {}
    };
  });
}
